/* eslint-disable react/prop-types */
import React, { useState, useCallback, memo } from 'react';

interface HamburgerMenuProps {
  open: boolean;
  onClick: () => void;
}

export const HamburgerMenu: React.FC<HamburgerMenuProps> = memo(({ open, onClick }) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    },
    [onClick]
  );

  const baseLineStyle: React.CSSProperties = {
    width: '100%',
    height: '2px',
    background: '#fff',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transformOrigin: 'center center',
  };

  return (
    <button
      onClick={onClick}
      onKeyDown={handleKeyDown}
      onTouchStart={() => setIsPressed(true)}
      onTouchEnd={() => setIsPressed(false)}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onMouseLeave={() => setIsPressed(false)}
      aria-label={open ? 'Close menu' : 'Open menu'}
      aria-expanded={open}
      style={{
        background: 'none',
        border: 'none',
        color: '#fff',
        cursor: 'pointer',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 0.2s ease',
        transform: isPressed ? 'scale(0.95)' : 'scale(1)',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: open ? '0' : '4px',
          width: '24px',
          height: '18px',
          position: 'relative',
        }}
      >
        {/* Top line */}
        <div
          style={{
            ...baseLineStyle,
            position: open ? 'absolute' : 'relative',
            top: open ? '50%' : 'auto',
            transform: open ? 'translateY(-50%) rotate(45deg)' : 'none',
          }}
        />
        {/* Middle line */}
        <div
          style={{
            ...baseLineStyle,
            opacity: open ? 0 : 1,
            transform: open ? 'scaleX(0)' : 'scaleX(1)',
          }}
        />
        {/* Bottom line */}
        <div
          style={{
            ...baseLineStyle,
            position: open ? 'absolute' : 'relative',
            top: open ? '50%' : 'auto',
            transform: open ? 'translateY(-50%) rotate(-45deg)' : 'none',
          }}
        />
      </div>
    </button>
  );
});

HamburgerMenu.displayName = 'HamburgerMenu';
